import * as React from "react";
import * as __intl__ from "@frameio/i18n";
import { type Language } from "../.././consts";
export type Text = {
    chooseLanguage: string;
    select: string;
    placeholder: string;
    visuallyHidden: (language: Language) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Text for language menu selection */
            chooseLanguage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LanguageMenu.chooseLanguage?c=1qe2icgth51d2", defaultMessage: "Choose language" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for selecting which lanuage is associated with the caption file */
            select: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LanguageMenu.select?c=1of9wmhs0jt7b", defaultMessage: "Select" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Placeholder for language seach bar */
            placeholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LanguageMenu.placeholder?c=1lo0efoyhj10j", defaultMessage: "Search\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible text describing the selected language */
            visuallyHidden: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (language: Language) => __intl__.intl().formatMessage({ id: "LanguageMenu.visuallyHidden?c=198gf0lxaycl5", defaultMessage: "Selected language: {language}" }, { language: language }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
